module.exports = __webpack_public_path__ + "media/point-2.53a90982.wav";